export const getSortKeysForUserActivitiesData = userActivityKey => {
  switch (userActivityKey) {
    case 'from':
      return 'from.location';
    case 'clientName':
      return 'client_name';
    case 'event':
      return 'type';
    default:
      return userActivityKey;
  }
};

export const getColumnsForUserActivitiesTable = t => {
  return [
    {
      Header: t('usersActivitiesPage.table.event'),
      accessor: 'type',
      id: 'event',
      width: 100,
      selectElementWidth: 120,
    },
    {
      Header: t('usersActivitiesPage.table.when'),
      accessor: 'when',
      id: 'when',
      width: 120,
      selectElementWidth: 120,
    },
    {
      Header: t('usersActivitiesPage.table.device'),
      accessor: 'device',
      id: 'device',
      width: 100,
      selectElementWidth: 120,
    },
    {
      Header: t('usersActivitiesPage.table.from'),
      accessor: 'from',
      id: 'from',
      width: 130,
      selectElementWidth: 200,
    },
  ];
};
